import * as React from "react";

const SvgIcnDashboards = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18 4a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h12zm0 1H6a1 1 0 00-1 1v7.74l1.278-1.278a1.3 1.3 0 011.839 0l2.118 2.119a.3.3 0 00.424 0L15.24 10h-1.75a.5.5 0 010-1h3.017a.5.5 0 01.5.5v3.018a.5.5 0 11-1 0l-.001-1.869-4.638 4.639a1.3 1.3 0 01-1.839 0L7.41 13.169a.3.3 0 00-.424 0L5 15.154V18a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1z"
        />
    </svg>
);

export default SvgIcnDashboards;
